import joi from 'joi';

import type { PartialRequireAtLeastOne } from '../../../types';
import { identity } from '../../../utils/functions';
import type { PolicyWithApiScopes } from '../../PolicyWithApiScopes';

type PolicyWithApiScopesRequestBodyBase = Omit<
  PolicyWithApiScopes,
  'id' | 'isSystem' | 'scopeType'
>;

const policyWithApiScopesRequestBodyBaseSchema = joi.object().keys(
  identity<joi.SchemaMap<PolicyWithApiScopesRequestBodyBase>>({
    name: joi.string().required(),
    description: joi.string().allow('').required(),
    apiScopeIds: joi.array().items(joi.string()).required(),
  }),
);

// POST /policies/scopes/api
export type PoliciesWithApiScopesPostRequestBody =
  PolicyWithApiScopesRequestBodyBase;
export const policiesWithApiScopesPostRequestBodySchema =
  policyWithApiScopesRequestBodyBaseSchema;
export type PoliciesWithApiScopesPostResponseBody = PolicyWithApiScopes;

// GET /policies/scopes/api/:policyKey
export type PolicyWithApiScopesGetResponseBody = PolicyWithApiScopes;

// PATCH /policies/scopes/api/:policyKey
export type PolicyWithApiScopesPatchRequestBody =
  PartialRequireAtLeastOne<PolicyWithApiScopesRequestBodyBase>;
export const policyWithApiScopesPatchRequestBodySchema =
  policyWithApiScopesRequestBodyBaseSchema
    .fork(['apiScopeIds', 'description', 'name'], (e) => e.optional())
    .min(1);
export type PolicyWithApiScopesPatchResponseBody = PolicyWithApiScopes;

// PUT /policies/scopes/api/:policyKey
export type PolicyWithApiScopesPutRequestBody =
  PolicyWithApiScopesRequestBodyBase;
export const policyWithApiScopesPutRequestBodySchema =
  policyWithApiScopesRequestBodyBaseSchema;
export type PolicyWithApiScopesPutResponseBody = PolicyWithApiScopes;
